module.exports = __webpack_public_path__ + "static/media/CoronaDE.6c32d1e5.pdf";